import React from 'react';

import { SEO } from 'main/components';
import {
  Specifications,
  Ecosystem,
  Landing,
  ForgeOperators,
  MissionReady,
  Video,
  RobustAirframe,
} from 'modules/mrm1';

export const Mrm1 = () => {
  return (
    <>
      <SEO seoTitle="FPV Training Drone - All in One Solution Made in EU - Orqa" />
      <section>
        <section className="mrm1-section">
          <Landing />
          <MissionReady />
          <RobustAirframe />
          <Ecosystem />
          <Specifications />
          <Video />
        </section>
        <ForgeOperators />
      </section>
    </>
  );
};
